import React__default from 'react';
import { M as MenuItemButton } from '../../../Menu/MenuItem/MenuItemButton-CNT0PKNu.js';

const SplitButtonItem = props => /*#__PURE__*/React__default.createElement(MenuItemButton, props);

export { SplitButtonItem as S };
//# sourceMappingURL=SplitButtonItem-Q0LHD6oa.js.map
